<template>
    <div>
        <div id="leftcolumn" class="cols">
            <div class="wrapper">ArtMarket Sales</div>
            <div class="section" v-if="viewingPending">
                <table>
                    <tr>
                        <th>Art Title</th>
                        <th>Processed</th>
                        <th>Order ID</th>
                        <th>Date</th>
                        <th>Sold At</th>
                        <th>Ship Needed</th>
                        <th>Tax TransID</th>
                        <th>Price</th>
                        <th>Payout</th>
                        <th>Tax</th>
                        <th>Paid</th>
                        <th>Discount</th>
                        <th>Seller</th>
                        <th>Buyer</th>
                    </tr>
                    <tr v-for="(order, index) in pending" :key="index">
                        <th @click="processOrder(order)">{{order.artTitle}}</th>
                        <th>{{order.processed}}</th>
                        <th>{{order.orderID}}</th>
                        <th>{{order.orderDate}}</th>
                        <th>{{order.artmarket}}</th>
                        <th>{{order.shipRequired}}</th>
                        <th>{{order.taxTransID}}</th>
                        <th>{{order.itemPrice}}</th>
                        <th>{{order.payOut}}</th>
                        <th>{{order.taxCost}}</th>
                        <th>{{order.totalPaid}}</th>
                        <th>{{order.museoDiscount/10}}</th>
                        <th>{{order.artistUsername}}</th>
                        <th>{{order.buyerUsername}}</th>
                    </tr>
                </table>
            </div>
            <div v-if="permissions == 'A'">
            <div class="processWindow" v-if="isProcessing">
                <div class="closeOrder" @click="closeOrder">X</div>
                <div class="actionBtn bgMint" @click="sendPayment">{{sendPaymentText}}</div>
                <div class="actionBtn bgPink" @click="commitTax">Commit Tax</div>
                <div class="actionBtn bgTeal" @click="salesTax">Submit Sales Tax</div>
            </div>
            </div>
        </div>
        <div id="rightcolumn" class="cols"></div>
    </div>
</template>

<script>
import firebase from 'firebase/app';
import moment from 'moment';
import 'firebase/functions'
import 'firebase/firestore'
import db from '../main'
export default {
    name:"sales",
    props: ["permissions"],
    data(){
        return {
            settled: [],
            pending: [],
            userID: "",
            order: {},
            sendPaymentText: "",
            viewingPending: true,
            isProcessing: false,
        }
    },
    mounted(){
        firebase.auth().onAuthStateChanged(user => {
            if (user){
                this.userID = firebase.auth().currentUser.uid
                this.fetchOrders()
            }
        })

    },
    methods: {
        salesTax(){
            const order = this.order
            const senddata = ({
                street:order.street,
                type : "SalesInvoice",
                unit : order.unit,
                city : order.city,
                zipcode : order.zipcode,
                country : order.country,
                price : order.itemPrice,
                document_Id : order.document_Id
            })

            const sendTax = firebase.functions().httpsCallable('salesTax')
            sendTax(senddata).then(result => {
                if (result){
                    alert('Success sending', result)
                }
            })
        },
        commitTax(){
            const transactionID = this.order.taxTransID;
            console.log(transactionID)

            const taxdata = ({
                taxTransID: transactionID
            })

            const sendTax = firebase.functions().httpsCallable('commitAVATAX')
            sendTax(taxdata).then(result => {
                if(result){
                    console.log(result)
                }
            })
        },
        sendPayment(){
            const orderinfo = this.order
            if (orderinfo == ""){
                alert('There is nothing to update')
                return
            }

            const payout = orderinfo.itemPrice - orderinfo.commission
            const stripepayout = parseInt(payout * 100)
            const datapass = ({
                artTitle: orderinfo.artTitle,
                username: orderinfo.artistUsername,
                artmarketID: orderinfo.artmarketID,
                user_Id: orderinfo.sellerID,
                commission: orderinfo.commission,
                itemPrice: orderinfo.itemPrice,
                mainURL: orderinfo.mainURL,
                orderID: orderinfo.orderID,
                taxCost: orderinfo.taxCost,
                payOut: stripepayout,
                displayPayOut: payout,
                taxTransID: orderinfo.taxTransID
            })

            console.log(datapass)
            const sendPayment = firebase.functions().httpsCallable('paymentsAM')
            sendPayment(datapass).then(result => {
                if (result){
                    console.log(result)
                    db.collection('orders').doc(orderinfo.orderID).update({processed:true}).then(() => {
                        console.log('Update of Order Document to true')
                    })
                }
            })
        },
        closeOrder(){
            this.order = {}
            this.isProcessing = false
        },
        processOrder(order){
            this.isProcessing = true
            this.order = order
            const payout = order.itemPrice - order.commission
            const stripepayout = parseInt(payout * 100)
            this.sendPaymentText = 'Send Payment $' + payout + " | " + stripepayout
        },
        fetchOrders(){
            this.settled = []
            this.pending = []
            console.log(this.userID)
            db.collection('orders').orderBy('ordered_on', 'desc').get().then(orderdocs => {
            if(orderdocs){
                orderdocs.forEach(orderdoc => {
                    const data = orderdoc.data()
                    const artmarketpurchase = data.artmarketPurchase
                    if (artmarketpurchase){
                        data.artmarket = 'Artmarket'
                    } else {
                        data.artmarket = 'In Person'
                    }

                    const processedStat = data.processed
                    if(!processedStat){
                        data.processed = false
                    }

                    const payout = data.itemPrice - data.commission
                    data.payOut = payout

                    const ordered_on = data.ordered_on
                    data.orderDate = moment(ordered_on.seconds *1000).format('ll')
                    this.pending.push(data)
                    // const status = data.processed || false
                    // if (status){
                    //     this.settled.push(data)
                    // } else {
                    //     this.pending.push(data)
                    // }
                })
            }
        })
        }
    }
}
</script>

<style scoped>
table, th, td {
  border-width: 1px;
  border-style: solid;
  border-color: #00a89d;
  text-align: left;
  padding: 1%;
  width: 100%;
}
.mainwrap {
    width: 100%;
    height: auto;
    float: left;
    clear: right;
    text-align: left;
}

.actionBtn {
    width: 100%;
    height: 50px;
    padding: 3%;
    text-align: center;
    margin-bottom: 10px;
    float: left;
    clear: right;
}

.closeOrder {
    width: 50px;
    height: auto;
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 5px;
    margin-right: 5px;
    background-color: #00a89d;
    color: white;
}

.processWindow {
    width: 50%;
    height: 100vh;
    background-color:#00a89d;
    position: fixed;
    top: 0;
    left: 0;
    padding: 3%;
    padding-top: 50px;
}

.spacer {
    width: 100%;
    height: 20px;
    float: left;
    clear: right;
}
    #mainhold {
    width: 100%;
    height: 55vh;
    background-color: white;
    position: relative;
    overflow: scroll;
    position: relative;
}

.cpointer {
    cursor: pointer;
}

.btn {
    width: auto;
    height: auto;
    padding: 2%;
    border-radius: 2vmin;
    text-align: center;
    color: white;
    float:right;
    clear: right;
}

#rightcol {
    width: auto;
    height: auto;
    position: fixed;
    top: 0;
    margin-top: 300px;
    right: 0;
    margin-left: 50vw;
}

.imgHolder {
    width: 50px;
    height: 50px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    float: left;
    clear: right;
}

.imgHolder2 {
    width: 250px;
    height: 250px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    float: left;
    clear: right;
}

.wrapper {
    width: 60%;
    float: left;
    clear: right;
    height: auto;
    text-align: right;
    margin-left: 20px;
}

.instyle {
    width: 100%;
    height: 50px;
    border-style: solid;
    background-color: azure;
    padding: 1%;
    float: left;
    clear: right;
    margin-bottom: 5px;
}

.wrapperr {
    width: 60%;
    float: left;
    clear: right;
    height: auto;
    text-align: left;
    margin-left: 20px;
}

.listingholder {
    width: 100%;
    height: auto;
    float: left;
    clear: right;
    padding: 2%;
    margin-bottom: 5px;
}

.cols {
    width: 100%;
    height: auto;
    float: left;
    clear: right;
    padding: 5%;
    border-right-color: #00a89d;
    border-right-width: 2px;
    overflow: scroll;
}
</style>